<template>
  <div>
    <teleport :to="body">
      <div class="overlay">
        <div class="overlay-right">
          <div class="overlay-right-header">
            <div style="font-weight: bold">项目资质要求</div>
            <div @click="onClose" style="cursor: pointer">
              <BaseSvg
                style="width: 20px; height: 20px"
                iconClass="close"
              ></BaseSvg>
            </div>
          </div>
          <div class="overlay-right-main">
            <div class="overlay-right-main__reuqire">
              <p v-for="item in requireList" :key="item">{{ item }}</p>
            </div>
            <div class="overlay-right-main__info">
              <table
                style="
                  width: 100%;
                  border: 1px solid #f0f0f0;
                  text-align: center;
                "
              >
                <thead style="background: #f0f0f0">
                  <tr>
                    <th style="width: 50%; border-right: 1px solid #f0f0f0">
                      姓名
                    </th>
                    <th style="width: 50%">手机号</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style="
                        width: 50%;
                        border-right: 1px solid #f0f0f0;
                        border-top: 1px solid #f0f0f0;
                      "
                    >
                      {{ personInfo.name }}
                    </td>
                    <td style="width: 50%; border-top: 1px solid #f0f0f0">
                      {{ personInfo.phone }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overlay-right-main__check">
              <p style="margin: 24px 0">终端服务人员已上传，点击查看</p>
              <div>
                <BaseRadioGroup v-model="showIndex">
                  <BaseRadio
                    v-for="(item, index) in quaDetail"
                    :key="item.qualificationsName"
                    :value="index"
                    style="margin: 5px"
                    size="large"
                    border
                  >
                    {{ item.qualificationsName }}
                  </BaseRadio>
                </BaseRadioGroup>
              </div>
            </div>
          </div>
          <div class="overlay-right-footer">
            <div>
              <BaseButton :disabled="!canAudit" @click="onAudit(1)" plain>
                通过
              </BaseButton>
              <BaseButton
                :disabled="!canAudit"
                type="default"
                @click="onAudit(0)"
                plain
              >
                不通过
              </BaseButton>
            </div>
          </div>
        </div>
        <div class="overlay-left">
          <BaseImageViewer
            v-if="imgViewerShow"
            :infinite="true"
            :preview-src-list="picList"
            :hide-close="true"
          ></BaseImageViewer>
        </div>
      </div>
    </teleport>
  </div>
</template>
<script lang="tsx" setup>
import { watch, ref, nextTick, computed } from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
import BaseInsert from './base-insert.vue';
import {
  BaseButton,
  BaseImageViewer,
  BaseRadioGroup,
  BaseRadio,
  createDialog
} from 'xrk-components';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { projectQualificationsInfo } from '../data-source/apis';
import { auditQua } from '../data-source/apis';

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const props = withDefaults(
  defineProps<{
    id: number;
    canAudit: boolean;
  }>(),
  {
    id: null,
    canAudit: false
  }
);

const body = document.body;

const imgViewerShow = ref(true);
const showIndex = ref(0);

const baseInsertRef = ref();

const auditId = ref(props.id);
const onAudit = async status => {
  if (!status) {
    createDialog({
      title: '审核不通过',
      width: 370,
      contentRender: () => {
        return (
          <>
            <BaseInsert
              labelPosition={'left'}
              ruleValidator={(rule: any, value: any, callback: any) => {
                if (value === '') {
                  return callback(new Error('请填写不通过原因，最少5个字'));
                } else if (value.length < 5) {
                  return callback(new Error('请填写不通过原因，最少5个字'));
                } else {
                  callback();
                }
              }}
              label={''}
              placeholder={'请填写不通过原因，最少5个字'}
              maxlength={150}
              show-word-limit={true}
              type="textarea"
              rows={8}
              ref={baseInsertRef}
            ></BaseInsert>
          </>
        );
      },
      async beforeConfirm(done) {
        const { data } = await baseInsertRef.value.getFormData();
        const { data: nextId } = await auditQua({
          projectId: projectInfo.value.id,
          userId: [auditId.value],
          auditStatus: 3,
          auditOpinion: data,
          auditType: 1
        });
        if (!nextId) {
          done();
          onClose();
          return;
        }
        auditId.value = nextId;
        init(nextId);
      }
    });
  } else {
    createDialog({
      width: 350,
      title: '提示',
      content: `是否确认通过，请谨慎操作`,
      beforeConfirm: async done => {
        const { data: nextId } = await auditQua({
          projectId: projectInfo.value.id,
          userId: [auditId.value],
          auditStatus: 2,
          auditType: 1
        });
        if (!nextId) {
          done();
          onClose();
          return;
        }
        auditId.value = nextId;
        init(nextId);
      }
    });
  }
};

const picList = ref([]); //图片列表

const requireList = ref([]);
const personInfo = ref({
  name: '',
  phone: null
});

const quaDetail = ref([]);

const init = async (nextId?: number) => {
  const { data } = await projectQualificationsInfo({
    userId: nextId || props.id,
    projectId: projectInfo.value.id
  });
  requireList.value = data.projectQualifications;
  personInfo.value = {
    name: data.name,
    phone: data.phone
  };
  quaDetail.value = data.projectQualificationsDetail;

  picList.value = quaDetail.value[
    showIndex.value
  ].projectQualificationsAttachment.map(item => item.attachmentUrl);
  if (!data.projectQualificationsDetail.length) {
    imgViewerShow.value = false;
  }
};
init();

watch(
  () => showIndex.value,
  v => {
    imgViewerShow.value = false;
    picList.value = quaDetail.value[v].projectQualificationsAttachment.map(
      item => item.attachmentUrl
    );
    nextTick(() => {
      imgViewerShow.value = true;
    });
  }
);

const emits = defineEmits(['close']);

const onClose = () => {
  emits('close');
};
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-image-viewer__mask {
    opacity: 0;
  }
}
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  &-right {
    z-index: 3000;
    position: absolute;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 16px 48px 16px rgba(0, 0, 0, 0.08),
      0px 12px 32px rgba(0, 0, 0, 0.12), 0px 8px 16px -8px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    width: 25%;
    height: 100%;
    right: 0;
    animation: slip_in 0.3s;
    &-header {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #72767b;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 22px 20px;
      border-bottom: 1px solid #c1c1c1;
    }
    &-main {
      height: calc(100vh - 160px);
      position: relative;
      overflow: auto;
      box-sizing: border-box;
      padding: 20px;
      &__reuqire {
        padding-bottom: 24px;
        border-bottom: 1px solid #f0f0f0;
      }
      &__info {
        margin-top: 24px;
      }
    }
    &-footer {
      text-align: right;
      height: 80px;
      background: #fff;
      border-top: 1px solid #c1c1c1;
      width: 100%;
      position: absolute;
      bottom: 0;
      padding: 25px 50px;
    }
  }
  &-left {
    width: 75%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    left: 0;
  }
}

/*右侧滑入*/
@keyframes slip_in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
